var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            width: "900px",
            title: _vm.$t("CargoMsg.Cargo_Preview")
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid" },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "150px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.headList.gridOptions,
                  "column-defs": _vm.headList.columnDefs,
                  "row-data": _vm.headListRowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "padding-top": "60px" }
            },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "200px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.detailList.gridOptions,
                  "column-defs": _vm.detailList.columnDefs,
                  "row-data": _vm.detailListRowData
                }
              })
            ],
            1
          ),
          _vm.fileListRowData.length > 0
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { "padding-top": "10px" }
                },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "100%", height: "200px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.fileList.gridOptions,
                      "column-defs": _vm.fileList.columnDefs,
                      "row-data": _vm.fileListRowData
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FinanceManage.Confirm")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }